import React from 'react';
import { Typography, Section, SectionSubTitle, List, ListItem } from 'common/components';
import { KITCHEN_CDN_PATH } from '../../old-kitchen-constants';
import {
  deliniaSection,
  deliniaLogo,
  deliniaContent,
  deliniaContentTitle,
  deliniaContentText,
  deliniaContentList,
} from './kitchen-delinia-section-styles';

export const KitchenDeliniaSection = () => (
  <Section className={deliniaSection}>
    <img
      alt="Кухни Delinia"
      className={deliniaLogo}
      src={`${KITCHEN_CDN_PATH}/delinia/delinia-logo2.png/delinia-logo2.png`}
      title="Кухни Delinia"
      width="117"
      height="64"
      loading="lazy"
    />

    <div className={deliniaContent}>
      <SectionSubTitle as="h2" className={deliniaContentTitle} margin="s">
        Delinia&nbsp;ID&nbsp;&mdash; 10&nbsp;лет на&nbsp;рынке
      </SectionSubTitle>
      <Typography variant="m" size="body_long" className={deliniaContentText}>
        Уже 10&nbsp;лет мы&nbsp;продаём кухни собственной торговой марки Delinia&nbsp;ID. Продукция
        Delinia&nbsp;ID прослужит долгие годы, ведь она эргономична и&nbsp;проста в&nbsp;уходе. Практичные
        дизайнерские решения позволят вам организовать комфортное и&nbsp;уютное пространство.
      </Typography>

      <List listStyle="disc" className={deliniaContentList}>
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            Большой выбор мебельной фурнитуры и&nbsp;аксессуаров
          </Typography>
        </ListItem>
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            Четкость и&nbsp;точность изготовления всех деталей
          </Typography>
        </ListItem>
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            Идеально ровные и&nbsp;гладкие поверхности
          </Typography>
        </ListItem>
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            Ручной контроль качества изделия
          </Typography>
        </ListItem>
      </List>
    </div>
  </Section>
);
